import { render, staticRenderFns } from "./CustomerFeedbackTab.vue?vue&type=template&id=50913a0a&"
import script from "./CustomerFeedbackTab.vue?vue&type=script&lang=ts&"
export * from "./CustomerFeedbackTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50913a0a')) {
      api.createRecord('50913a0a', component.options)
    } else {
      api.reload('50913a0a', component.options)
    }
    module.hot.accept("./CustomerFeedbackTab.vue?vue&type=template&id=50913a0a&", function () {
      api.rerender('50913a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/CustomerFeedbackTab.vue"
export default component.exports